import PropTypes from 'prop-types'

const TimeCircle = ({
  width = '24',
  height = '24',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 23"
    fill="none"
    className={className}
    {...{ ...props }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Time Circle">
      <circle
        id="Ellipse 32"
        cx="11.5"
        cy="11.5"
        r="10"
        stroke="#7A858C"
        strokeWidth="1.5"
      />
      <path
        id="Vector 132"
        d="M11.5 7.5V11.2324C11.5 11.3996 11.5836 11.5557 11.7226 11.6484L14.5 13.5"
        stroke="#7A858C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
)

TimeCircle.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

TimeCircle.defaultProps = {
  width: '24',
  height: '24',
  className: '',
}

export default TimeCircle
